import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/domains';
import { FORM_REPOSITORY } from '../../core';
import { FORM_API } from '../data-sources';
export var FormWebRepository = /*#__PURE__*/function () {
  function FormWebRepository(formApi) {
    _classCallCheck(this, FormWebRepository);

    this.formApi = formApi;
  }

  _createClass(FormWebRepository, [{
    key: "findByIds",
    value: function () {
      var _findByIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formIds) {
        var responseOrError, formStatusCheckList;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.formApi.findByIds(formIds);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                formStatusCheckList = responseOrError.getValue();
                return _context.abrupt("return", Result.ok(formStatusCheckList));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function findByIds(_x) {
        return _findByIds.apply(this, arguments);
      }

      return findByIds;
    }()
  }, {
    key: "getSectionSummaries",
    value: function () {
      var _getSectionSummaries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var responseOrError, sectionSummaryResponses;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.formApi.getSectionSummaries(input);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                sectionSummaryResponses = responseOrError.getValue();
                return _context2.abrupt("return", Result.ok(sectionSummaryResponses));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSectionSummaries(_x2) {
        return _getSectionSummaries.apply(this, arguments);
      }

      return getSectionSummaries;
    }()
  }, {
    key: "findById",
    value: function () {
      var _findById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var id, checkHasEssayOrFillInBlank, inputWithSearchParams, responseOrError, formResponse;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = input.id, checkHasEssayOrFillInBlank = input.checkHasEssayOrFillInBlank;
                inputWithSearchParams = "".concat(id, "?checkHasEssayOrFillInBlank=").concat(checkHasEssayOrFillInBlank);
                _context3.next = 4;
                return this.formApi.findById(inputWithSearchParams);

              case 4:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", mappingResultError(responseOrError));

              case 7:
                formResponse = responseOrError.getValue();
                return _context3.abrupt("return", Result.ok(formResponse));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function findById(_x3) {
        return _findById.apply(this, arguments);
      }

      return findById;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.formApi.create(input);

              case 2:
                responseOrError = _context4.sent;

                if (!responseOrError.isFailure) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue();
                return _context4.abrupt("return", Result.ok(successMessage));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function create(_x4) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "import",
    value: function () {
      var _import2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(input) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.formApi["import"](input);

              case 2:
                responseOrError = _context5.sent;

                if (!responseOrError.isFailure) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue();
                return _context5.abrupt("return", Result.ok(successMessage));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _import(_x5) {
        return _import2.apply(this, arguments);
      }

      return _import;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(useCaseInput) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.formApi.update(useCaseInput);

              case 2:
                responseOrError = _context6.sent;

                if (!responseOrError.isFailure) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue();
                return _context6.abrupt("return", Result.ok(successMessage));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function update(_x6) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.formApi["delete"](id);

              case 2:
                responseOrError = _context7.sent;

                if (!responseOrError.isFailure) {
                  _context7.next = 5;
                  break;
                }

                return _context7.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue();
                return _context7.abrupt("return", Result.ok(successMessage));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _delete(_x7) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "createSection",
    value: function () {
      var _createSection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(section) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.formApi.createSection(section);

              case 2:
                responseOrError = _context8.sent;

                if (!responseOrError.isFailure) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue();
                return _context8.abrupt("return", Result.ok(successMessage));

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function createSection(_x8) {
        return _createSection.apply(this, arguments);
      }

      return createSection;
    }()
  }, {
    key: "updateSection",
    value: function () {
      var _updateSection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(section) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.formApi.updateSection(section);

              case 2:
                responseOrError = _context9.sent;

                if (!responseOrError.isFailure) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue();
                return _context9.abrupt("return", Result.ok(successMessage));

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function updateSection(_x9) {
        return _updateSection.apply(this, arguments);
      }

      return updateSection;
    }()
  }, {
    key: "deleteSection",
    value: function () {
      var _deleteSection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(useCaseInput) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.formApi.deleteSection(useCaseInput);

              case 2:
                responseOrError = _context10.sent;

                if (!responseOrError.isFailure) {
                  _context10.next = 5;
                  break;
                }

                return _context10.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue();
                return _context10.abrupt("return", Result.ok(successMessage));

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function deleteSection(_x10) {
        return _deleteSection.apply(this, arguments);
      }

      return deleteSection;
    }()
  }, {
    key: "createHeading",
    value: function () {
      var _createHeading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(input) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.formApi.createHeading(input);

              case 2:
                responseOrError = _context11.sent;

                if (!responseOrError.isFailure) {
                  _context11.next = 5;
                  break;
                }

                return _context11.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context11.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function createHeading(_x11) {
        return _createHeading.apply(this, arguments);
      }

      return createHeading;
    }()
  }, {
    key: "updateHeading",
    value: function () {
      var _updateHeading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(input) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.formApi.updateHeading(input);

              case 2:
                responseOrError = _context12.sent;

                if (!responseOrError.isFailure) {
                  _context12.next = 5;
                  break;
                }

                return _context12.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context12.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function updateHeading(_x12) {
        return _updateHeading.apply(this, arguments);
      }

      return updateHeading;
    }()
  }, {
    key: "deleteHeading",
    value: function () {
      var _deleteHeading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(input) {
        var responseOrError, headingId;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.formApi.deleteHeading(input);

              case 2:
                responseOrError = _context13.sent;

                if (!responseOrError.isFailure) {
                  _context13.next = 5;
                  break;
                }

                return _context13.abrupt("return", mappingResultError(responseOrError));

              case 5:
                headingId = responseOrError.getValue();
                return _context13.abrupt("return", Result.ok(headingId));

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function deleteHeading(_x13) {
        return _deleteHeading.apply(this, arguments);
      }

      return deleteHeading;
    }()
  }, {
    key: "advancedSearch",
    value: function () {
      var _advancedSearch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(input) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this.formApi.advancedSearch(input));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function advancedSearch(_x14) {
        return _advancedSearch.apply(this, arguments);
      }

      return advancedSearch;
    }()
  }, {
    key: "clone",
    value: function () {
      var _clone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(input) {
        var responseOrError, formResponse;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.formApi.clone(input);

              case 2:
                responseOrError = _context15.sent;

                if (!responseOrError.isFailure) {
                  _context15.next = 5;
                  break;
                }

                return _context15.abrupt("return", mappingResultError(responseOrError));

              case 5:
                formResponse = responseOrError.getValue();
                return _context15.abrupt("return", Result.ok(formResponse));

              case 7:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function clone(_x15) {
        return _clone.apply(this, arguments);
      }

      return clone;
    }()
  }]);

  return FormWebRepository;
}();
export var formWebRepositoryProvider = {
  provide: FORM_REPOSITORY,
  useFactory: function useFactory(formApi) {
    return new FormWebRepository(formApi);
  },
  inject: [FORM_API]
};